import { defineBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine';
import style from './block.module.scss';
import Logo from './Logo';
import NavMenu from './NavMenu';
import HeaderButton from './HeaderButton';
import { useMediaQuery } from '@material-ui/core';
import BurgerButton from './BurgerButton';
import React, { useState, useEffect } from 'react';
import MenuMobile from './MenuMobile';
import clsx from 'clsx';

const Inspector = React.lazy(() => import('./Inspector'));

function Header({ menu, textBtn, linkBtn , currentPage }) {
    useInspectorControl(Inspector);
    const isDesktop = useMediaQuery(`(min-width: calc(${style.laptopBreakpoint} + 1px))`);
    const [burgerOpen, setOpenBurger] = useState(false);
    const [stickyStyle, setStickyStyle] = useState(false);

    useEffect(() => {
        function headerChange() {
            setStickyStyle(window.pageYOffset > 300);
        }

        function watchScroll() {
            window.addEventListener('scroll', headerChange);
        }

        watchScroll();

        return () => {
            window.removeEventListener('scroll', headerChange);
        };
    }, []);

    useEffect(() => {
        if (burgerOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'visible';
        }
    }, [burgerOpen]);

    return (
        <>
            {isDesktop ? (
                <nav className={clsx(style.block, stickyStyle && style.sticky)}>
                    <Logo styleAlt={stickyStyle} />
                    <NavMenu menu={menu} currentPage={currentPage}/>
                    <HeaderButton text={textBtn} link={linkBtn} />
                </nav>
            ) : (
                <>
                    <div className={style.mobileHeader}>
                        <Logo />
                        <BurgerButton isOpen={burgerOpen} setOpen={setOpenBurger} />
                    </div>
                    <MenuMobile isOpen={burgerOpen} menu={menu} text={textBtn} link={linkBtn} currentPage={currentPage}/>
                </>
            )}
        </>
    );
}

export default defineBlock({
    Block: Header,
    smartProps: {
        logoMain: smartProps.image,
        logoAlt: smartProps.image,
        textBtn: smartProps.string.withDefault('Texte du bouton'),
        linkBtn: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Header',
    },
});
